import copy from 'copy-to-clipboard';

// 超级分享海报
const supshotData = () => {
    let supshotConfig = {};

    if (typeof location !== 'object') {
        return supshotConfig;
    }

    // 超级分享海报开关
    if (!window.SUPSHOTSWITCH) {
        return supshotConfig;
    }
    if (location.href.includes('supshot=1')) {
        supshotConfig = {
            kind: 'inter_cjfx01',
            download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7269195431041713152',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9175',
            noKindFrom: 1,
        };
    }

    if (location.href.includes('supshot=2')) {
        supshotConfig = {
            kind: 'inter_cjfx02',
            download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7269195527678477312',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9176',
            noKindFrom: 1,
        };
    }

    if (location.href.includes('supshot=3')) {
        supshotConfig = {
            kind: 'inter_cjfx03',
            download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7269195725246877696',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9177',
            noKindFrom: 1,
        };
    }

    return supshotConfig;
};

const TOOL = {
    UA: typeof navigator === 'object' ? navigator.userAgent.toLocaleLowerCase() : '',
    isPC() {
        return !this.UA.match(/android/) && !this.UA.match(/iphone/) && !this.UA.match(/arkweb/);
    },
    isAndroid() {
        return this.UA.match(/android/);
    },
    isWeixinWork() {
        return this.UA.match(/wxwork/);
    },
    isHarmony() {
        return this.UA.match(/arkweb/);
    },
    isWeixin() {
        return this.UA.match(/micromessenger/) && !this.UA.match(/wxwork/);
    },
    isQQ() {
        return this.UA.match(/qq\//);
    },
    isWeibo() {
        return this.UA.match(/weibo/);
    },
    isUCBrowser() {
        return (
            (this.UA.match(/ucbrowser/) || this.UA.match(/ u;/)) &&
            !this.UA.match(/miuibrowser/) &&
            !this.UA.match(/vivobrowser/) &&
            !this.UA.match(/oppo/) &&
            !this.UA.match(/mqqbrowser/) &&
            !this.UA.match(/heytapbrowser/)
        );
    },
    isBaiduBrowser() {
        return this.UA.match(/baidubrowser/);
    },
    isMiBrowser() {
        return this.UA.match(/miuibrowser/);
    },
    isVivoBrowser() {
        return this.UA.match(/vivobrowser/);
    },
    isQQBrowser() {
        return this.UA.match(/mqqbrowser/);
    },
    isSupportSorage() {
        return (() => {
            let isfastmode = 1;

            try {
                localStorage.setItem('sorageSign', 1);
                isfastmode = 0;
            } catch (e) {
                console.error(e);
            }

            return isfastmode;
        })();
    },
    getSession(key) {
        if (this.isSupportSorage()) return '';

        return JSON.parse(sessionStorage.getItem(key)) || '';
    },
    setSession(key, value) {
        if (this.isSupportSorage()) return '';

        sessionStorage.setItem(key, JSON.stringify(value));
    },
    getQuery(url, key) {
        let value = '';

        try {
            const urlObj = new URL(url);
            const { searchParams } = urlObj;

            if (searchParams.has(key)) {
                value = searchParams.get(key);
            }
        } catch (e) {
            console.error(e);
        }

        return value;
    },
    getHash(hash, key) {
        const params = hash.replace('#', '').split('&');
        let ret = '';

        if (params) {
            for (let i = 0, len = params.length; i < len; i++) {
                const pair = params[i].split('=');

                if (key === pair[0]) {
                    ret = pair[1];
                }
            }
        }

        return ret;
    },
};

// oppowatch梳理
const oppowatchData = (param) => {
    const oppowatConfig = {};

    if (typeof location !== 'object') {
        return oppowatConfig;
    }
    const oppowatchuid = TOOL.getQuery(window.location.href, 'oppowatchuid');

    if (!oppowatchuid || !param?.pid) {
        return oppowatConfig;
    }
    let pid = param?.pid;

    if (
        param?.docType === 'article' ||
        param?.docType === 'short' ||
        param?.docType === 'doc' ||
        param?.docType === 'slide'
    ) {
        pid = `${param?.pid}&oppowatchuid=${oppowatchuid}`;
    }

    return {
        pid,
        kind: 'brand_oppl11',
        download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7271573017562501120',
        downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9178',
        noKindFrom: 1,
    };
};

// 从url中获取schemeUrl并自动拉端
const autoCallApp = () => {
    if (typeof window !== 'object') return false;
    if (!TOOL.isWeibo() && TOOL.getHash(location.hash, 'schemeUrl')) {
        location.href = decodeURIComponent(TOOL.getHash(location.hash, 'schemeUrl'));
    }
};

// 监听hash变化
const hashChangeHandle = () => {
    if (typeof window !== 'object') return false;
    window.addEventListener('hashchange', autoCallApp);
};

autoCallApp();
hashChangeHandle();

/**
 * 拉新拉活客户端组件
 * @param {Object} params 扩展参数，参数内容如下
 *   @param {String} client 客户端类型(默认newsApp)[newsApp|videoApp]
 *   @param {String} docType 拉活文章类型[awake|video|phvideo|zmt|source|hotspotnew|hotspotlist|vampire|web|topic2|topic3|short|article|solenewslist|personalPage]
 *   @param {String} pid 文章数据标识
 *   @param {String} kind 客户端统计标识(存在默认值)
 *   @param {String} userId 个人账号id
 *   @param {Number || Boolean} hasComment 是否拉起评论位(默认无)
 *   @param {Number || Boolean} noKindFrom  kind值是否有文章来源(默认有)
 *   @param {Number || Boolean} isSecretCall 是否静默拉起(默认无)
 *   @param {String} secretGoUrl 静默拉起失败跳转链接
 *   @param {String} download 应用宝链接(存在默认值)
 *   @param {String} downloadAd 下载链接(存在默认值)
 *   @param {String} domainApi IOS拉起头(存在默认值)
 *   @param {String} protocolApi scheme协议头(存在默认值)
 *   @param {String} guidePage 落地页地址(存在默认值)
 *   @param {Function} failCallback 回调函数
 *
 */
const callAppMenu = {
    clientName: 'newsApp',
    addressStore: {
        newsApp: {
            download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1473191364941',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8819',
            domainApi: 'https://api.iclient.ifeng.com/wakeupiOS/ifengnews/call',
            guidePage: 'https://ishare.ifeng.com/ucTransfer',
            protocolApi: 'comifengnewsclient://call',
            harmonyAppLinkHost: 'https://shankapi.ifeng.com/call/hmosnews',
        },
        videoApp: {
            download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.newvideo&ckey=CK1351861306533',
            downloadAd: 'https://api.3g.ifeng.com/ifengvideo_tg34?vt=5',
            domainApi: 'https://api.iclient.ifeng.com/wakeupiOS/video/call',
            guidePage: 'https://ishare.ifeng.com/ucTransfer',
            protocolApi: 'ifengVideoPlayer://call',
            harmonyAppLinkHost: 'https://shankapi.ifeng.com/call/hmosvideo',
        },
        classicalApp: {
            download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1473191364941',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8819',
            domainApi: 'https://api.iclient.ifeng.com/wakeupiOS/ifengTVClassic2025/call',
            guidePage: 'https://classical.ifeng.com/loc/callAppGuide',
            protocolApi: 'ifengtvclassical://call',
            harmonyAppLinkHost: 'https://shankapi.ifeng.com/call/hmosclassical',
        },
        ALink: {
            download: '',
            downloadAd: '',
            domainApi: '',
            guidePage: '',
            protocolApi: '',
            harmonyAppLinkHost: 'https://shankapi.ifeng.com/call',
        },
    },
    harmonyDownUrl: 'store://appgallery.huawei.com/app/detail?id=com.ifeng.news.hmos',
    isCopySchemeUrl: true,
    failCallback: null,
    failTimeout: 3000,
    init(params = {}) {
        if (typeof window !== 'object') return false;
        this.clientName = params.client || 'newsApp';
        this.failCallback = params.failCallback || null;
        this.isEnterClient = false;
        this.isCopySchemeUrl = params.isCopySchemeUrl ?? true;
        if (!this.addressStore[this.clientName]) return false;
        this.paramsHandle(params);
        this.sendStatistics(
            this.getApiId(params.docType, params.pid),
            this.getDocType(params.docType, params.client),
            params.kind,
        );
        if (params.client !== 'videoApp' && (params.mode === 'ALink' || window.__ALink__)) {
            this.handleALink(params);
        } else {
            this.clientHandle(params);
        }
    },
    getSchemeLink(params = {}) {
        this.clientName = params.client || 'newsApp';
        this.isEnterClient = false;
        if (!this.addressStore[this.clientName]) return false;
        this.paramsHandle(params);

        const clientName = this.clientName;
        const protocolApi = this.addressStore[clientName].protocolApi;
        const paramsPath = this.paramsPath;

        return `${protocolApi}?${paramsPath}`;
    },
    getWebAppLink(params = {}) {
        const type = params.docType || 'doc';
        const from = params.from || 'wxh5';
        const id = params.pid || '';
        let webappLink = `pages/index/index.html?from=${from}`;

        if (type) {
            webappLink = `pages/new/new.html?type=${type}&aid=${id}&from=${from}`;
        }

        if (type === 'doc' || type === 'article') {
            webappLink = `pages/new/new.html?type=${type}&aid=${id}&from=${from}`;
        }

        if (type === 'video' || type === 'phvideo') {
            webappLink = `pages/new/new.html?types=${type}&aid=${id}&from=${from}`;
        }

        if (type === 'topic2' || type === 'topic3') {
            webappLink = `pages/specialPage/specialPage.html?type=${type}&url=${id}&staticId=special_${id}&from=${from}`;
        }

        if (type === 'short' || type === 'shortCustom') {
            webappLink = `pages/short/short.html?type=${type}&aid=${id}&from=${from}`;
        }

        return webappLink;
    },
    handleALink(params = {}) {
        if (typeof window !== 'object') {
            return '';
        }
        const kind = (params.kind && `${encodeURIComponent(this.kindForm())}${params.kind}`) || 'sf_downopen';

        const aman = params.aman || TOOL.getQuery(window.location.href, 'aman');
        const filterParams = this.getFilterParams(params);
        const schemeParams = {
            type: this.getDocType(params.docType, params.client),
            id: this.getApiId(params.docType, params.pid),
            kind,
            aman,
            ref: params.ref || window.location.href?.split?.('#')?.[0],
            playState: 1,
            comment: params.hasComment || 0,
            ...filterParams,
        };
        const tr_param1 = window.btoa ? window.btoa(JSON.stringify(schemeParams)) : JSON.stringify(schemeParams);

        if (window?.__ALink__?.invokeOrInstall) {
            window.__ALink__.invokeOrInstall({
                tr_param1,
                tr_param2: encodeURIComponent(kind),
                tr_shareuser: encodeURIComponent(aman),
            });
        }
    },
    paramsHandle(params) {
        const clientName = this.clientName;
        let download = this.addressStore[clientName].download;
        let domainApi = this.addressStore[clientName].domainApi;
        let guidePage = this.addressStore[clientName].guidePage;
        let downloadAd = this.addressStore[clientName].downloadAd;
        let protocolApi = this.addressStore[clientName].protocolApi;
        let harmonyAppLinkHost = this.addressStore[clientName].harmonyAppLinkHost;

        if (typeof window !== 'object') {
            return '';
        }
        const filterParams = this.getFilterParams(params);
        const schemeParams = {
            type: this.getDocType(params.docType, params.client),
            id: encodeURIComponent(this.getApiId(params.docType, params.pid)),
            kind: params.kind || 'sf_downopen',
            ref: params.ref || encodeURIComponent(decodeURIComponent(window.location.href?.split?.('#')?.[0])),
            playState: 1,
            comment: params.hasComment || 0,
            ...filterParams,
        };

        this.addressStore[clientName].download = params.download ? params.download : download;
        this.addressStore[clientName].domainApi = params.domainApi ? params.domainApi : domainApi;
        this.addressStore[clientName].guidePage = params.guidePage ? params.guidePage : guidePage;
        this.addressStore[clientName].downloadAd = params.downloadAd ? params.downloadAd : downloadAd;
        this.addressStore[clientName].protocolApi = params.protocolApi ? params.protocolApi : protocolApi;
        this.addressStore[clientName].harmonyAppLinkHost = params.harmonyAppLinkHost
            ? params.harmonyAppLinkHost
            : harmonyAppLinkHost;
        this.isSecretCall = params.isSecretCall || 0;
        this.secretGoUrl = params.secretGoUrl || '';
        this.noKindFrom = params.noKindFrom || 0;
        this.paramsPath = this.paramsFormat(schemeParams, params.pid);
        this.failTimeout = params.failTimeout || 3000;
    },
    clientHandle(params) {
        this.PCHandle();
        this.secretCallHandle();
        this.weixinWorkHandle();
        this.weixinHandle();
        this.QQHandle();
        this.weiboHandle(params);
        this.UCHandle();
        this.finalHandle();
    },
    PCHandle() {
        if (!TOOL.isPC() || this.isEnterClient) return false;
        this.isEnterClient = true;
        let locationUrl = 'https://a.ifeng.com/?from=home';

        this.jumpUrl(locationUrl, 0);
    },
    finalHandle() {
        if (this.isEnterClient) return false;
        const isAndroid = TOOL.isAndroid();
        const isHarmony = TOOL.isHarmony();
        const clientName = this.clientName;
        const downloadAd = this.addressStore[clientName].downloadAd;
        const protocolApi = this.addressStore[clientName].protocolApi;
        const domainApi = this.addressStore[clientName].domainApi;
        const harmonyAppLinkHost = this.addressStore[clientName].harmonyAppLinkHost;
        const paramsPath = this.paramsPath;
        let locationUrl = '';

        if (isAndroid) {
            locationUrl = `${protocolApi}?${paramsPath}`;
            this.jumpUrl(locationUrl, 50);
            setTimeout(() => {
                if (this.failCallback) {
                    this.failCallback();
                } else {
                    window.location.href = downloadAd;
                }
            }, this.failTimeout);
        } else if (isHarmony) {
            locationUrl = `${harmonyAppLinkHost}?${paramsPath}`;
            this.jumpUrl(locationUrl, 50);
        } else {
            locationUrl = `${domainApi}?${paramsPath}&remind=1`;
            this.jumpUrl(locationUrl, 50);
        }
    },
    weixinWorkHandle() {
        if (!TOOL.isWeixinWork() || this.isEnterClient) return false;
        this.isEnterClient = true;
        const isAndroid = TOOL.isAndroid();
        const isHarmony = TOOL.isHarmony();
        const clientName = this.clientName;
        const download = this.addressStore[clientName].download;
        const protocolApi = this.addressStore[clientName].protocolApi;
        const domainApi = this.addressStore[clientName].domainApi;
        const harmonyAppLinkHost = this.addressStore[clientName].harmonyAppLinkHost;
        const paramsPath = this.paramsPath;
        let locationUrl = '';
        const schemeUrl = `${protocolApi}?${paramsPath}`;

        if (isAndroid) {
            if (this.isCopySchemeUrl) {
                copy(schemeUrl);
            }
            setTimeout(() => {
                if (this.failCallback) {
                    this.failCallback();

                    return false;
                }
                this.addTipsTemplate();
                this.isCloseGuideFixed();
            }, 100);
        } else if (isHarmony) {
            locationUrl = `${harmonyAppLinkHost}?${paramsPath}`;
            this.jumpUrl(locationUrl, 50);
        } else {
            locationUrl = `${domainApi}?${paramsPath}&remind=1`;
            this.jumpUrl(locationUrl, 50);
        }
    },
    weixinHandle() {
        if (!TOOL.isWeixin() || this.isEnterClient) return false;
        this.isEnterClient = true;
        const isAndroid = TOOL.isAndroid();
        const isHarmony = TOOL.isHarmony();
        const clientName = this.clientName;
        const download = this.addressStore[clientName].download;
        const protocolApi = this.addressStore[clientName].protocolApi;
        const domainApi = this.addressStore[clientName].domainApi;
        const paramsPath = this.paramsPath;
        const schemeUrl = `${protocolApi}?${paramsPath}`;
        const harmonyAppLinkHost = this.addressStore[clientName].harmonyAppLinkHost;
        const qqLink = `${download}&android_scheme=${encodeURIComponent(schemeUrl)}`;
        let locationUrl = '';

        if (isAndroid) {
            if (this.isCopySchemeUrl) {
                copy(schemeUrl);
            }
            if (this.failCallback) {
                this.failCallback();
            } else {
                locationUrl = qqLink;
                this.jumpUrl(locationUrl, 50);
            }
        } else if (isHarmony) {
            locationUrl = `${harmonyAppLinkHost}?${paramsPath}`;
            this.jumpUrl(locationUrl, 50);
        } else {
            locationUrl = `${domainApi}?${paramsPath}&remind=1`;
            this.jumpUrl(locationUrl, 50);
        }
    },
    QQHandle() {
        if (!TOOL.isQQ() || this.isEnterClient) return false;
        this.isEnterClient = true;
        const isAndroid = TOOL.isAndroid();
        const isHarmony = TOOL.isHarmony();
        const clientName = this.clientName;
        const download = this.addressStore[clientName].download;
        const protocolApi = this.addressStore[clientName].protocolApi;
        const paramsPath = this.paramsPath;
        const harmonyAppLinkHost = this.addressStore[clientName].harmonyAppLinkHost;
        const schemeUrl = `${protocolApi}?${paramsPath}`;
        let locationUrl = '';

        if (this.isCopySchemeUrl) {
            copy(schemeUrl);
        }
        if (isAndroid) {
            if (this.failCallback) {
                this.failCallback();
            } else {
                this.jumpUrl(`${download}&android_scheme=${encodeURIComponent(schemeUrl)}`, 50);
            }
        } else if (isHarmony) {
            locationUrl = `${harmonyAppLinkHost}?${paramsPath}`;

            this.jumpUrl(locationUrl, 50);
        } else {
            this.jumpUrl(`${download}&android_scheme=${encodeURIComponent(schemeUrl)}`, 50);
        }
    },
    UCHandle() {
        if (!TOOL.isUCBrowser() || this.isEnterClient) return false;
        this.isEnterClient = true;
        const isAndroid = TOOL.isAndroid();
        const isHarmony = TOOL.isHarmony();
        const clientName = this.clientName;
        const downloadAd = this.addressStore[clientName].downloadAd;
        const download = this.addressStore[clientName].download;
        const domainApi = this.addressStore[clientName].domainApi;
        const guidePage = this.addressStore[clientName].guidePage;
        const protocolApi = this.addressStore[clientName].protocolApi;
        const paramsPath = this.paramsPath;
        const harmonyAppLinkHost = this.addressStore[clientName].harmonyAppLinkHost;
        const schemeUrl = `${protocolApi}?${paramsPath}`;
        let locationUrl = '';

        if (isAndroid) {
            locationUrl = `${protocolApi}?${paramsPath}`;
            this.jumpUrl(locationUrl, 50);
            setTimeout(() => {
                if (this.failCallback) {
                    this.failCallback();
                } else {
                    window.location.href = downloadAd;
                }
            }, this.failTimeout);
            // locationUrl = `${guidePage}?${encodeURIComponent(schemeUrl)}`;
        } else if (isHarmony) {
            locationUrl = `${harmonyAppLinkHost}?${paramsPath}`;

            this.jumpUrl(locationUrl, 50);
        } else {
            locationUrl = `${domainApi}?${paramsPath}&remind=1`;
            this.jumpUrl(locationUrl, 50);

            // locationUrl = `${download}&android_scheme=${encodeURIComponent(schemeUrl)}`;
        }

        if (this.isCopySchemeUrl) {
            copy(schemeUrl);
        }
        // this.jumpUrl(locationUrl, 50);
    },
    // 静默拉起
    secretCallHandle() {
        const isAndroid = TOOL.isAndroid();
        const isHarmony = TOOL.isHarmony();
        const clientName = this.clientName;
        const secretGoUrl = this.secretGoUrl;
        const harmonyAppLinkHost = this.addressStore[clientName].harmonyAppLinkHost;
        let locationUrl = '';

        if (!this.isSecretCall || !secretGoUrl || this.isEnterClient) {
            return false;
        }

        this.isEnterClient = true;

        if (TOOL.getSession('secretCallSign')) {
            this.jumpUrl(secretGoUrl, 50);

            return false;
        }

        TOOL.setSession('secretCallSign', 1);

        if (isAndroid) {
            locationUrl = `${this.addressStore[clientName].protocolApi}?${this.paramsPath}`;

            setTimeout(() => {
                if (this.failCallback) {
                    this.failCallback();
                } else {
                    window.location.href = secretGoUrl;
                }
            }, this.failTimeout);
        } else if (isHarmony) {
            locationUrl = `${harmonyAppLinkHost}?${this.paramsPath}`;

            this.jumpUrl(locationUrl, 50);
        } else {
            locationUrl = `${this.addressStore[clientName].domainApi}?${this.paramsPath}&gourl=${encodeURIComponent(
                secretGoUrl,
            )}&remind=1`;
        }

        this.jumpUrl(locationUrl);
    },

    // 拉起kind值处理
    kindForm() {
        if (this.noKindFrom) return '';
        if (TOOL.isWeixin()) {
            return 'inter|wx_';
        } else if (TOOL.isQQ()) {
            return 'inter|qq_';
        } else if (TOOL.isWeibo() || location.href.includes('#from=weibo')) {
            return 'inter|wb_';
        } else {
            return 'inter|other_';
        }
    },
    getFilterParams(params) {
        const fliterAttribute = [
            'client',
            'mode',
            'docType',
            'pid',
            'kind',
            'hasComment',
            'noKindFrom',
            'isSecretCall',
            'secretGoUrl',
            'download',
            'downloadAd',
            'domainApi',
            'protocolApi',
            'guidePage',
            'failCallback',
            'failTimeout',
            'harmonyAppLinkHost',
        ];
        let result = {};

        for (const key of Object.keys(params)) {
            if (params[key] === '') continue;

            if (!fliterAttribute.includes(key)) {
                result[key] = params[key];
            }
        }

        return result;
    },
    // 拉起参数格式化
    paramsFormat(config, pid) {
        const paramsCollect = [];
        let paramsStr = '';

        for (const key of Object.keys(config)) {
            if (!config[key] || config[key] === 'undefined') continue;
            if (key === 'kind') {
                // 添加encodeURIComponent否则IOS不支持
                paramsCollect.push(`${key}=${encodeURIComponent(this.kindForm())}${config[key]}`);
            } else {
                paramsCollect.push(`${key}=${config[key]}`);
            }
        }
        const timeStamp = TOOL.isAndroid() ? new Date().getTime() : new Date().getTime().toString().slice(0, 10);

        // if (TOOL.isAndroid()) {
        paramsCollect.push(`timeStamp=${timeStamp}`);
        // }

        if (config.type === 'custom') {
            paramsStr = pid;
        } else {
            paramsStr = paramsCollect.join('&');
        }

        return paramsStr;
    },
    // 获取拉起类型
    getDocType(type, client) {
        const docTypeMapRelate = {
            video: 'phvideo',
            vampire: 'doc',
            short: 'doc',
            article: 'doc',
        };

        if (client === 'classicalApp' && type === 'video') {
            return 'video';
        }

        return docTypeMapRelate[type] || type || 'doc';
    },
    // 获取拉起id值
    getApiId(type, pid) {
        const nineDomain = typeof window === 'object' && window.allData?.__nd__ ? window.allData.__nd__ : 'ne883dbn.ifeng.com'
        const articleDataApi = `https://${nineDomain}/GetNewsDocs`;
        const topicDataApi = 'https://api.iclient.ifeng.com/TopicApiForCmpp';
        const topic3DataApi = `https://${nineDomain}/newTopic`;
        const vampireDataApi = 'https://api.iclient.ifeng.com/api_vampire_article_detail?gv=5.5.5&doc=1';
        const idMapRelate = {
            awake: '',
            // 'video': pid,
            // 'phvideo': pid,
            // 'zmt': pid,
            // 'source': pid,
            // 'hotspotnew': pid,
            // 'hotspotlist': pid,
            // 'solenewslist': pid,
            // 'personalPage': pid,
            // 'web': pid,
            doc: `${articleDataApi}?aid=${pid}`,
            slide: `${articleDataApi}?aid=${pid}`,
            vampire: `${vampireDataApi}&aid=${pid}`,
            topic2: `${topicDataApi}?topicid=${pid}&json=y`,
            topic3: `${topic3DataApi}?topicid=${pid}&json=y`,
            short: `${articleDataApi}?aid=${pid}`,
            article: `${articleDataApi}?aid=${pid}`,
        };
        const idApi = idMapRelate[type] !== undefined ? idMapRelate[type] : pid;

        return idApi;
    },
    // 统计
    sendStatistics(id, type, kind) {
        const imgDom = document.createElement('img');
        const idApi = `${decodeURIComponent(id)}&kind=${kind}`;
        const statisticsUrl = 'https://api.iclient.ifeng.com/shareArticle';
        const timeStamp = TOOL.isAndroid() ? new Date().getTime() : new Date().getTime().toString().slice(0, 10);

        if (!id || !type || !kind) return false;
        imgDom.src = `${statisticsUrl}?type=${type}&id=${encodeURIComponent(idApi)}&timeStamp=${timeStamp}`;
        imgDom.style.display = 'none';
        document.body.appendChild(imgDom);
        setTimeout(() => {
            document.body.removeChild(imgDom);
        }, 500);
    },
    isCloseGuideFixed() {
        const guideFixed = document.querySelector('#guideFixed');

        if (guideFixed) {
            guideFixed.addEventListener('click', () => {
                guideFixed.parentNode.removeChild(guideFixed);
            });
        }
    },
    // 微博端处理
    weiboHandle(params) {
        if (!TOOL.isWeibo()) return false;
        this.isEnterClient = true;
        const clientName = this.clientName;
        const paramsPath = this.paramsPath;
        const downloadAd = this.addressStore[clientName].downloadAd;
        const download = this.addressStore[clientName].download;
        const guideUrl = 'https://ishare.ifeng.com/loc/weiboCallAppGuide';

        if (this.failCallback) {
            this.failCallback();
        } else {
            location.href = `${guideUrl}?${paramsPath}&downloadAd=${encodeURIComponent(
                downloadAd,
            )}&download=${encodeURIComponent(download)}&docType=${params.docType}&pid=${encodeURIComponent(
                params.pid,
            )}`;
        }
    },
    addTipsTemplate() {
        document
            .querySelector('body')
            .insertAdjacentHTML(
                'beforeend',
                '<section id="guideFixed" style="position: fixed;width: 100%;height: 100%;top: 0; left: 0;background: #ececec; z-index:99999;"><img style="width:100%" src ="http://p2.ifengimg.com/ifengimcp/pic/20190507/21ab0fc3fd400f8e387e_size58_w750_h1334.png"></secton>',
            );
    },
    jumpUrl(url, time) {
        setTimeout(() => {
            window.location.href = url;
        }, time);
    },
};

const callApp = (params) => {
    params = {
        ...params,
        ...supshotData(),
        ...oppowatchData(params),
    };

    callAppMenu.init(params);
};

const getSchemeLink = (params) => {
    params = {
        ...params,
        ...supshotData(),
        ...oppowatchData(params),
    };

    return callAppMenu.getSchemeLink(params);
};

const getWebAppLink = (params) => {
    params = {
        ...params,
        ...supshotData(),
        ...oppowatchData(params),
    };

    return callAppMenu.getWebAppLink(params);
};

export { callApp, getSchemeLink, getWebAppLink };
